import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'

import colors from 'components/utils/colors'

import TableBody from 'components/Shared/TableNew/TableBody'

const StyledTableBody = styled(TableBody)`
  border: 1px solid ${colors.secondary95};
  border-top: 1px solid transparent;
  ${props => props.isHidden && css`
    display: none;
  `}
`

const TableFormBody = ({ children, isHidden }) => {
  return (
    <StyledTableBody hoverable={false} isHidden={isHidden}>
      {children}
    </StyledTableBody>
  )
}

TableFormBody.propTypes = {
  children: PropTypes.node,
  isHidden: PropTypes.bool,
}

export default TableFormBody
